<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 7078 7078"
 xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <path :style="{fill: color}" d="M3539 0c-1955,0 -3539,1585 -3539,3539 0,1955 1584,3539 3539,3539 1955,0 3539,-1584 3539,-3539 0,-1954 -1584,-3539 -3539,-3539zm-631 5497l0 0c-37,68 -107,107 -179,107 -33,0 -66,-8 -98,-25 -34,-19 -849,-468 -849,-1225 0,-387 210,-690 397,-956 164,-237 319,-460 319,-713 0,-507 -608,-873 -615,-877 -97,-57 -130,-182 -74,-279 57,-98 182,-130 279,-74 33,20 818,483 818,1230 0,381 -209,681 -394,946 -166,238 -323,464 -323,723 0,509 630,863 636,867 99,53 136,177 83,276zm1229 0l0 0c-37,68 -107,107 -179,107 -33,0 -66,-8 -97,-25 -34,-19 -850,-468 -850,-1225 0,-387 210,-690 396,-956 164,-237 320,-460 320,-713 0,-507 -608,-873 -615,-877 -97,-57 -130,-182 -74,-279 57,-98 182,-130 279,-74 33,20 817,483 817,1230 0,381 -208,681 -392,946 -166,238 -324,464 -324,723 0,509 630,863 637,867 98,53 136,177 82,276zm1229 0l0 0c-37,68 -107,107 -179,107 -33,0 -66,-8 -97,-25 -34,-19 -850,-468 -850,-1225 0,-387 210,-690 396,-956 164,-237 320,-460 320,-713 0,-511 -609,-874 -615,-878 -97,-56 -130,-181 -74,-278 57,-97 182,-130 279,-74 33,20 817,483 817,1230 0,381 -209,681 -393,946 -166,238 -323,464 -323,723 0,509 630,863 637,867 98,53 136,177 82,276z"/>
 </g>
</svg>
</template>

<script>
export default {
  name: 'HeatDevice',
  props: {
    color: {
      type: String,
      required: false,
      default: '#CCCCCC',
    },
  },
};
</script>

<style scoped>
</style>
